<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Blog</p>
          <div>
            <el-tooltip content="Insert" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click.prevent="insert()"
              ></el-button>
            </el-tooltip>
            <Dialog />
          </div>
        </div>
        <Table />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/blog/Table'
import Dialog from '../components/blog/Dialog'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Table,
    Dialog
  },

  computed: {
    ...mapState('blog', ['loading'])
  },

  methods: {
    ...mapMutations('blog', ['setDialog', 'setSelectedBlog']),
    initialBlog() {
      return {
        id: null,
        name: '',
        title: null,
        text: null,
        short_text: null,
        image_url: null
      }
    },
    insert() {
      this.setDialog(true)
      this.setSelectedBlog(this.initialBlog())
    }
  }
}
</script>
